<template>
  <div id="app">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
#nprogress .bar {
  background: #29d !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 999999 !important;
  height: 3px !important;
}

/* html, body, #app {
  height: 100%;
  margin: 0;
  padding: 0;
  width: 100%;
} */
</style>